export { StandardAvatar } from './StandardAvatar';
